export default __webpack_public_path__ + "static/media/Rectangle6549.a579fa93.png";